/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttendanceStatus } from './AttendanceStatus';
import {
    AttendanceStatusFromJSON,
    AttendanceStatusFromJSONTyped,
    AttendanceStatusToJSON,
    AttendanceStatusToJSONTyped,
} from './AttendanceStatus';

/**
 * Set one status on several attendance rows of a workshop.
 * @export
 * @interface WorkshopAttendanceBulkStatus
 */
export interface WorkshopAttendanceBulkStatus {
    /**
     * 
     * @type {Array<string>}
     * @memberof WorkshopAttendanceBulkStatus
     */
    attendance_ids: Array<string>;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof WorkshopAttendanceBulkStatus
     */
    status: AttendanceStatus;
    /**
     * 
     * @type {AttendanceStatus}
     * @memberof WorkshopAttendanceBulkStatus
     */
    only_status?: AttendanceStatus | null;
}



/**
 * Check if a given object implements the WorkshopAttendanceBulkStatus interface.
 */
export function instanceOfWorkshopAttendanceBulkStatus(value: object): value is WorkshopAttendanceBulkStatus {
    if (!('attendance_ids' in value) || value['attendance_ids'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function WorkshopAttendanceBulkStatusFromJSON(json: any): WorkshopAttendanceBulkStatus {
    return WorkshopAttendanceBulkStatusFromJSONTyped(json, false);
}

export function WorkshopAttendanceBulkStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceBulkStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'attendance_ids': json['attendance_ids'],
        'status': AttendanceStatusFromJSON(json['status']),
        'only_status': json['only_status'] == null ? undefined : AttendanceStatusFromJSON(json['only_status']),
    };
}

export function WorkshopAttendanceBulkStatusToJSON(json: any): WorkshopAttendanceBulkStatus {
    return WorkshopAttendanceBulkStatusToJSONTyped(json, false);
}

export function WorkshopAttendanceBulkStatusToJSONTyped(value?: WorkshopAttendanceBulkStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'attendance_ids': value['attendance_ids'],
        'status': AttendanceStatusToJSON(value['status']),
        'only_status': AttendanceStatusToJSON(value['only_status']),
    };
}

